import { TrendsType } from "reedy-data/models";
import Google from "~/components/svg/icons/google";
import Amazon from "~/components/svg/icons/amazon";
import { Text } from "~/components/text";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "~/components/ui/select";
import { capitalizeFirstLetter } from "~/utils/helpers";

const icons = {
  [TrendsType.GOOGLE]: <Google />,
  [TrendsType.AMAZON]: <Amazon />,
};
export const SearchTermsSourceSelect = ({
  trends,
  onChange,
  value,
}: {
  trends: TrendsType[];
  onChange: (trend: TrendsType) => void;
  value: TrendsType;
}) => (
  <Select onValueChange={onChange} value={value}>
    <SelectTrigger data-testid="trends-type-select" className="w-[180px]">
      <SelectValue placeholder="Trend type" />
    </SelectTrigger>
    <SelectContent>
      <SelectGroup>
        {trends.map((type) => (
          <SelectItem
            key={type}
            value={type}
            data-testid={`trend-menu-item-${type.toLowerCase()}`}
          >
            <div className="flex flex-row gap-2 items-center">
              {icons[type]}
              <Text>{capitalizeFirstLetter(type)}</Text>
            </div>
          </SelectItem>
        ))}
      </SelectGroup>
    </SelectContent>
  </Select>
);
